<template>
  <div class="mainElemetManagementContainer">
    <div class="buttonContainer">
      <div class="addDiv">
        <el-button @click="add()" v-if="null !== addPermission" class="addBtn">
          {{ addPermission.name }}<i class="el-icon-plus el-icon--right"></i>
        </el-button>
      </div>

      <div id="queryDiv">
        <el-form :model="queryForm" @submit.native.prevent>
          <el-form-item label="">
            <el-input
              v-model="queryForm.name"
              placeholder="搜索"
              @keyup.enter.native="handleCurrentChange(1)"
              ><i
                class="el-icon-search"
                slot="suffix"
                @click="handleCurrentChange(1)"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="mainTableContainer">
      <el-table
        class="table"
        :data="videoDataTableData"
        height="491"
        style="width: 100%"
        ref="commonTable"
      >
       <el-table-column
          v-for="recordItem in videoDataTableColumnLists"
          :key="recordItem.prop"
          :prop="recordItem.prop"
          :label="recordItem.label"
          :min-width="recordItem.minWidth"
          :align="recordItem.align"
          :show-overflow-tooltip="recordItem.showOverflowTooltip"
        ></el-table-column>

        <el-table-column
          label="操作"
          min-width="150"
          align="center"
        >
          <template slot-scope="scope">
            <div class="buttonCol" @click="seeDetailHandle(scope.row)">
                <i class="els-icon-video"></i>
                <span>视频播放</span>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div
        style="text-align:right; margin-top:15px; margin-right:0px; height: 40px;"
        id="pages"
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="current"
          :page-sizes="[6, 16, 24, 32]"
          :page-size="size"
          layout="total, sizes, prev, pager, next"
          :total="totalCount"
          popper-class="adminHomeSelect"
        />
      </div>
    </div>

    <!-- 查看详情 模态框 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="824px"
      class="commonDialog"
      @close="closeDetailHandle"
    >
      <div class="videoDataContent">
         <div class="videoTitle">
           视频播放
         </div>
         <div class="videoContent">

         </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { deepCopy } from '@/utils/tools.js'

export default {
  name: 'videoDataManagement',
  data() {
    return {
      addPermission: null,
      // 存储搜索信息
      queryForm: {
        name: ''
      },
      // 存储 视频数据 表格数据
      videoDataTableData: [],
      // 定义 视频数据 各列相关信息
      videoDataTableColumnLists: [
        {
          prop: "uas_serial_id",
          label: "任务编号",
          minWidth: "150",
          align: "center",
          showOverflowTooltip: true
        },
        {
          prop: "user_id",
          label: "任务名称",
          minWidth: "150",
          align: "center",
          showOverflowTooltip: true
        },
        {
          prop: "local_id",
          label: "计划编号",
          minWidth: "150",
          align: "center",
          showOverflowTooltip: true
        },
        {
          prop: "flight_name",
          label: "计划名称",
          minWidth: "150",
          align: "center",
          showOverflowTooltip: true
        },
        {
          prop: "created_at",
          label: "执行日期",
          minWidth: "150",
          align: "center",
          showOverflowTooltip: true
        }
      ],
      // 存储单条视频数据信息
      singleVideoDataData: {},
      // 查看详情模态框 显示隐藏
      dialogVisible: false,
      // 当前页数
      current: 1,
      // 每页显示条数
      size: 6,
      // 总条数
      totalCount: 0
    }
  },
  created() {
    this.query()
  },
  mounted() {
    this.setGutterWidth();
  },
  methods: {
    // 搜索视频数据信息 - 分页函数 - 每页显示条数改变触发的事件
    handleSizeChange(size) {
      this.size = size;
      this.query();
    },
    // 搜索视频数据信息 - 分页函数 - 页码改变触发的事件
    handleCurrentChange(current) {
      this.current = current;
      this.query();
    },
    // 查询 获取 视频数据信息
    query() {
      this.getRequest(
        "/uav-task-server/flight/getFlightListForFlightManage.do?"
        + "pagesize=" + this.size 
        + "&currentpage=" + this.current
        + "&keyword=" + this.queryForm.name
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (null != res.data && !this.isEmptyArray(res.data.list)) {
              this.$data.totalCount = res.data.total;
              console.log(deepCopy(res.data.list))
              this.$data.videoDataTableData = deepCopy(res.data.list)
            } else {
              this.$data.totalCount = 0;
              this.$data.videoDataTableData = [];
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch(() => {});
    },
    // 查看单条视频数据详细信息
    seeDetailHandle(row) {
      this.querySingleVideoDataDetailInfo(row.id)
      this.dialogVisible = true;
    },
    // 查询单条视频
    querySingleVideoDataDetailInfo(id) {
      this.getRequest(
          "/uav-task-server/flight/getFlightDetailForFlightManage.do?flightId=" + id
        ).then((res) => {
          if(res.status === 200) {
            res = res.data
            if (null != res && 0 == res.code) {
              console.log(deepCopy(res.data))
              this.singleVideoDataData = deepCopy(res.data)
            }
          }
        })
    },
    // 关闭按钮事件
    closeDetailHandle() {
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
  @import "../../../assets/css/admin/videoDataManagement.css";
</style>



// WEBPACK FOOTER //
// src/components/admin/management/videoDataManagement.vue